<maps-drawer label="Weight and prioritize qualifications" [wide]="true" (closed)="closed.emit()" #drawer>
    <div drawerTitle class="heading" data-testid="weighting-drawer">
        <h2>Weight &amp; prioritize qualifications</h2>
        <p class="sub">Adjust which qualifications matter most to re-rank your candidates.</p>
    </div>

    <p class="explainer">
        These qualifications were extracted from the job description. Set how strongly each one affects
        ranking — <strong class="req">Required</strong> excludes candidates who lack it; the rest adjust
        rank without excluding.
    </p>

    <div class="summary-strip" role="status">
        <span class="req">{{ summary.required }} required</span>
        <span class="dot" aria-hidden="true">·</span>
        <span class="pref">{{ summary.preferred }} preferred</span>
        <span class="dot" aria-hidden="true">·</span>
        <span class="off">{{ summary.off }} off</span>
    </div>

    <ul class="cards">
        <li
            *ngFor="let row of rows; trackBy: TrackByRow"
            class="card"
            [class]="'card card--' + row.segment">
            <div class="card-top">
                <p class="text">{{ row.draft.text }}</p>
                <button
                    *ngIf="CanDelete(row)"
                    type="button"
                    class="delete"
                    [attr.aria-label]="'Delete qualification ' + row.draft.text"
                    (click)="DeleteCustom(row)">
                    ×
                </button>
            </div>
            <div class="segments" role="radiogroup" [attr.aria-label]="'Weight for ' + row.draft.text">
                <button
                    *ngFor="let seg of segmentKeys"
                    type="button"
                    role="radio"
                    [class]="SegmentClass(seg)"
                    [class.is-active]="row.segment === seg"
                    [attr.aria-checked]="row.segment === seg"
                    (click)="OnSegment(row, seg)">
                    {{ segmentLabels[seg] }}
                </button>
            </div>
        </li>
    </ul>

    <div class="add-row">
        <input
            type="text"
            placeholder="Add a qualification"
            aria-label="Add a qualification"
            [(ngModel)]="addText"
            (keydown.enter)="AddQualification()" />
        <button type="button" class="add-btn" [disabled]="!addText.trim()" (click)="AddQualification()">
            Add
        </button>
    </div>

    <div drawerFooter class="footer-actions">
        <button type="button" class="btn secondary" (click)="drawer.Close()">Cancel</button>
        <button
            type="button"
            class="btn primary"
            data-testid="weighting-primary"
            [disabled]="primaryDisabled"
            (click)="OnPrimary()">
            {{ primaryLabel }}
        </button>
    </div>
</maps-drawer>
